import { useQuery } from '@hooks/reactQuery';

import { getOrganizationDashboardRentsSummary } from '@api/dashboardPO';

import { extractQueryParams } from '@utils/common';

import { IDashboardOrganizationRentGeneralDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_RENTS_SUMMARY_ORGANIZATION } from '@constants/queryKeys';

const useQueryOrganizationDashboardRentsSummary = (params: IDashboardOrganizationRentGeneralDTO) => {
	const {
		fromText,
		toText,
		id,
	} = params;

	const {
		data: organizationDashboardRentsSummary,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [DASHBOARD_RENTS_SUMMARY_ORGANIZATION, params],
		queryFn: extractQueryParams(getOrganizationDashboardRentsSummary),
		enabled: [!!fromText, !!toText, !!id],
		...refetchOptions,
	});

	return {
		organizationDashboardRentsSummary,
		isLoadingOrganizationDashboardRentsSummary: (isLoading && !!organizationDashboardRentsSummary) || isFetching,
	};
};

export default useQueryOrganizationDashboardRentsSummary;

